import { motion } from "framer-motion";
import { Sun, Thermometer, Building2 } from "lucide-react";
import { IMAGES } from "../lib/images";
import { Reveal } from "./Reveal";

const sites = [
  {
    addr: "Via Kennedy 5",
    tag: "Sede principale",
    depts: ["Fresatura", "Tornitura", "Collaudo", "Sala Metrologica", "Ufficio Tecnico"],
  },
  {
    addr: "Via Kennedy 7",
    tag: "Produzione",
    depts: ["Tornitura", "Macchine Tradizionali", "Saldatura"],
  },
  {
    addr: "Via Kennedy 9",
    tag: "Nuova acquisizione strategica",
    depts: ["Reparto Rettifica", "6 macchine interni ed esterni", "Ciclo produttivo completo"],
  },
];

const sustainability = [
  { icon: Sun, title: "Impianto Fotovoltaico", desc: "Energia pulita autoprodotta per alimentare il ciclo produttivo e ridurre l'impronta ambientale." },
  { icon: Thermometer, title: "Climatizzazione Integrale", desc: "Capannoni interamente climatizzati: il controllo termico costante garantisce stabilità dimensionale e tolleranze perfette in ogni lavorazione." },
];

export const Infrastructure = () => (
  <section id="sedi" data-testid="infrastructure" className="relative overflow-hidden border-t border-white/10">
    <div className="absolute inset-0">
      <img src={IMAGES.facility} alt="Sede Cobi Meccanica" className="w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-black/80" />
    </div>

    <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
      <Reveal>
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-px bg-red-600" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Infrastruttura</span>
        </div>
        <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none max-w-3xl mb-6">
          Tre sedi produttive
        </h2>
        <p className="max-w-xl text-zinc-400 leading-relaxed mb-14">
          Fondata nel 1985, Cobi Meccanica ha ampliato la propria infrastruttura su tre stabilimenti
          produttivi in Via John Fitzgerald Kennedy, organizzati per reparto e flusso di lavoro: un
          ecosistema integrato nel cuore della zona industriale Torrazzi a Modena.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {sites.map((s, i) => (
          <Reveal key={s.addr} delay={i * 0.1}>
            <motion.div whileHover={{ y: -6 }} data-testid={`site-${i}`} className="border border-white/15 bg-black/40 backdrop-blur-sm p-8 h-full">
              <div className="flex items-center justify-between mb-8">
                <Building2 className="text-red-600" size={26} strokeWidth={1.4} />
                <span className="font-display font-black text-3xl text-white/10">0{i + 1}</span>
              </div>
              <h3 className="font-display font-bold text-2xl tracking-tight mb-1">{s.addr}</h3>
              <p className="font-mono text-[11px] uppercase tracking-wider text-red-600 mb-6">{s.tag}</p>
              <ul className="space-y-2.5">
                {s.depts.map((d) => (
                  <li key={d} className="flex items-center gap-3 text-sm text-zinc-300">
                    <span className="w-1.5 h-1.5 bg-red-600 rotate-45 shrink-0" />
                    {d}
                  </li>
                ))}
              </ul>
            </motion.div>
          </Reveal>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-10">
        {sustainability.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={i * 0.12}>
              <div data-testid={`sustainability-${i}`} className="flex gap-5 border border-white/15 bg-black/40 backdrop-blur-sm p-8 h-full">
                <div className="text-red-600 shrink-0"><Icon size={30} strokeWidth={1.4} /></div>
                <div>
                  <h3 className="font-display font-bold text-2xl tracking-tight mb-2">{s.title}</h3>
                  <p className="text-zinc-400 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
